import {
  LOAD_CHECKINS_REQUEST,
  LOAD_CHECKINS_SUCCESS,
  LOAD_CHECKINS_FAILURE,
  SET_CHECKIN_REQUEST,
  SET_CHECKIN_SUCCESS,
  SET_CHECKIN_FAILURE,
  SET_NOSHOW_REQUEST,
  SET_NOSHOW_SUCCESS,
  SET_NOSHOW_FAILURE,
  SET_WAIVER_FORM_SUBMITTED_REQUEST,
  SET_WAIVER_FORM_SUBMITTED_SUCCESS,
  SET_WAIVER_FORM_SUBMITTED_FAILURE,
} from "../constants";

import {
  getCheckins,
  updateNoShow,
  updateCheckIn,
  updateWaiverFormSubmitted,
} from "../middleware/api/checkin";

export function requestCheckins(date) {
  return (dispatch) => {
    dispatch({ type: LOAD_CHECKINS_REQUEST });
    return getCheckins(date)
      .then((data) => {
        dispatch({
          type: LOAD_CHECKINS_SUCCESS,
          data,
        });
      })
      .catch(() => {
        dispatch({ type: LOAD_CHECKINS_FAILURE });
      });
  };
}

export function setCheckin(id, newValue) {
  return (dispatch) => {
    dispatch({ type: SET_CHECKIN_REQUEST, id, newValue });
    return updateCheckIn(id, newValue)
      .then(() => {
        dispatch({
          type: SET_CHECKIN_SUCCESS,
          id,
          newValue,
        });
      })
      .catch(() => {
        dispatch({
          type: SET_CHECKIN_FAILURE,
          id,
          newValue,
        });
      });
  };
}

export function setNoShow(id, newValue) {
  return (dispatch) => {
    dispatch({ type: SET_NOSHOW_REQUEST, id, newValue });
    return updateNoShow(id, newValue)
      .then(() => {
        dispatch({
          type: SET_NOSHOW_SUCCESS,
          id,
          newValue,
        });
      })
      .catch(() => {
        dispatch({
          type: SET_NOSHOW_FAILURE,
          id,
          newValue,
        });
      });
  };
}

export function setWaiverFormSubmitted(id, newValue) {
  return (dispatch) => {
    dispatch({ type: SET_WAIVER_FORM_SUBMITTED_REQUEST, id, newValue });
    return updateWaiverFormSubmitted(id, newValue)
        .then(() => {
          dispatch({
            type: SET_WAIVER_FORM_SUBMITTED_SUCCESS,
            id,
            newValue,
          });
        })
        .catch(() => {
          dispatch({
            type: SET_WAIVER_FORM_SUBMITTED_FAILURE,
            id,
            newValue,
          });
        });
    };
  }
  


/** WEBPACK FOOTER **
 ** ./src/actions/checkin.js
 **/